var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 15.999,
    viewBox: "0 0 15.999 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-dropdown",
    d: "M670.061-9051.142a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1Zm.5-1.5h13v-7.37h-13Zm0-8.523h13v-4.477h-13Zm1.934,7a.57.57,0,0,1-.571-.571.572.572,0,0,1,.571-.573l6.069,0a.572.572,0,0,1,.573.571.571.571,0,0,1-.573.571Zm.059-2.819a.569.569,0,0,1-.56-.573.566.566,0,0,1,.56-.571h8.854a.566.566,0,0,1,.56.571.567.567,0,0,1-.56.573Zm7.7-5.635-1-1.16a.573.573,0,0,1,.059-.808.575.575,0,0,1,.808.059l.655.758.653-.758a.575.575,0,0,1,.808-.059.571.571,0,0,1,.059.808l-1,1.16a.686.686,0,0,1-.519.239A.694.694,0,0,1,680.254-9062.622Z",
    transform: "translate(-669.062 9067.141)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownWidget);
export default __webpack_public_path__ + "static/media/DropdownWidget.230a4eda.svg";
export { ForwardRef as ReactComponent };